import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_NOTE_FORM,
    CLEAR_NOTE_FORM_ERROR,
    CLEAR_NOTE_FORM_FIELD,
    CLEAR_NOTE_FORM_FIELD_ERROR,

    CHANGE_NOTE_FORM_FIELD,
    CHANGE_NOTE_FORM_FIELDS,

    VALIDATE_NOTE_FORM,

    SAVE_NOTE_REQUEST,
    SAVE_NOTE_SUCCESS,
    CHANGE_ERROR
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_NOTE_FORM,
    CLEAR_ERROR: CLEAR_NOTE_FORM_ERROR,
    CLEAR_FIELD: CLEAR_NOTE_FORM_FIELD,
    CLEAR_FIELD_ERROR: CLEAR_NOTE_FORM_FIELD_ERROR,
    CHANGE_FIELD: CHANGE_NOTE_FORM_FIELD,
    CHANGE_FIELDS: CHANGE_NOTE_FORM_FIELDS,
    VALIDATE: VALIDATE_NOTE_FORM,
    SUBMIT_REQUEST: SAVE_NOTE_REQUEST,
    SUBMIT_SUCCESS: SAVE_NOTE_SUCCESS,
    SUBMIT_FAILURE: CHANGE_ERROR
}